module.exports = [{"icon":"fireball","title":"灵感采集","model":"LingGanCaiJi"},{"icon":"fireball","title":"界面交互","model":"JieMianJiaoHu"},{"icon":"fireball","title":"设计规范","model":"SheJiGuiFan"},{"icon":"fireball","title":"在线工具","model":"ZaiXianGongJu"},{"icon":"fireball","title":"Icon图标","model":"Icon"},{"icon":"fireball","title":"设计素材","model":"SheJiSuCai"},{"icon":"fireball","title":"图库素材","model":"TuKuSuCai"},{"icon":"fireball","title":"颜色搭配","model":"YanSeDaPei"},{"icon":"fireball","title":"字体字形","model":"ZiTiZiXing"},{"icon":"fireball","title":"设计团队","model":"SheJiTuanDui"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/_list.json
// module id = 3
// module chunks = 0